<template>
  <el-container class="land-container">
    <el-header
      @mouseover.native="isdefault=false"
      @mouseleave.native="leave()"
      height="64px"
      class="land-header"
      :class="isdefault?'defaultColor':'headerColor'"
    >
      <div class="land-header-div" :style="{transform:'translateX('+headerOffset+'px)'}">
        <div class="land-header-navs">
          <router-link to="/">
            <div
              class="land-header-logo"
              @click="toTop"
            >
              <img :src="isdefault ? logoUrl : logo1" />
            </div>
          </router-link>
          <div class="land-header-menu">
            <el-menu
              :default-active="$router.currentRoute.path"
              class="el-menu-demo"
              mode="horizontal"
              router
            >
              <el-menu-item
                index="/home"
                @click.native="clickHome"
              >
                <router-link to="/">首页</router-link>
              </el-menu-item>
              <el-submenu index="2">
                <template slot="title">
                  <span
                    id="buttonFlag"
                    class="submenu-title"
                  >解决方案</span>
                </template>
                <el-menu-item
                  @click.native="clickSolution(item.clientGroup)"
                  :index="(item.clientGroup==='建设方') ? solutionRouter[0]:solutionRouter[1]"
                  v-for="(item,index) in solutionList"
                  :key="index"
                >
                  <span class="link-text"> {{item.clientGroup}}数字新成本解决方案</span>
                  <!-- <router-link
                    :to="{path:solutionRouter[index]}"
                    class="link-text">
                    {{item.clientGroup}}数字新成本解决方案
                  </router-link> -->
                </el-menu-item>
              </el-submenu>
              <el-menu-item index="/application" @click.native="clickCase()">应用案例
              </el-menu-item>
              <el-menu-item index="/dynamic" @click.native="clickNews()">动态
              </el-menu-item>
              <!--<el-menu-item index="5">-->
              <!--<router-link to="/understand" style="text-decoration: none;" >了解成本平台</router-link>-->
              <!--</el-menu-item>-->
            </el-menu>
          </div>
          <div class="land-header-btn">
            <el-button @click="handleLogin(geipToken)">{{geipToken ? '项目中心' : '登录'}}</el-button>
          </div>
        </div>
      </div>
    </el-header>
    <el-scrollbar
      wrap-style="overflow-x: hidden;"
      style="width: 100%; height: 100%; overflow-x: hidden;"
      ref="scrollMenuRef"
    >
      <el-main style="padding: 0; overflow: hidden; margin: auto;">
        <router-view />
      </el-main>
      <el-footer style="padding: 0; height: 308px;">
        <LandFooter />
      </el-footer>
    </el-scrollbar>
    <el-backtop
      target="#app .el-scrollbar__wrap"
      :bottom="40"
      :visibility-height="100"
    >
      <div style="text-align: center; line-height: 40px;">
        <i
          class="iconfont icon-arrow-up1"
          style="color: #FFF; font-size: 24px;"
        ></i>
      </div>
    </el-backtop>
  </el-container>
</template>

<script>
import LandFooter from './components/land-footer/LandFooter.vue'
import { getSolutionList } from '@/api/landing'
import { scrollTopFun } from '@/utils/universalFun.js'
const staticLogoUrl = require('@/assets/images/browser/img/logo-white.png')
const staticLogo1 = require('@/assets/images/browser/img/logo-color.png')

export default {
  name: 'land-page',
  components: {
    LandFooter
  },
  data () {
    return {
      activeIndex: '1',
      logoUrl: staticLogoUrl,
      logo1: staticLogo1,
      isdefault: true,
      solutionList: [],
      solutionRouter: ['/developer', '/contractor'],
      headerOffset: 0
    }
  },
  computed: {
    geipToken () {
      return window.localStorage.getItem('geipToken')
    }
  },
  mounted () {
    this.$refs.scrollMenuRef.wrap.addEventListener('scroll', this.scrollMenu)
    this.getList()
    window.addEventListener('scroll', this.headerScroll, true)
  },
  methods: {
    // 白色导航
    scrollMenu () {
      if (this.$refs.scrollMenuRef.wrap.scrollTop > 191) {
        this.isdefault = false
      } else {
        this.isdefault = true
      }
    },
    // 默认导航
    leave () {
      if (this.$refs.scrollMenuRef.wrap.scrollTop <= 191) {
        this.isdefault = true
      }
    },
    // 获取解决方案列表
    getList () {
      getSolutionList().then(res => {
        const { code, data, message } = res
        if (code === 200) {
          this.solutionList = data || []
        } else {
          this.solutionList = []
          message && this.$message.error(message)
        }
      }).catch(() => {
        this.solutionList = []
      })
    },
    // 登录
    handleLogin (geipToken) {
      if (geipToken) {
        window.location.href = `${window.location.protocol}//${window.location.host}/portal/?applicationCode=dcost&productCode=dcost&menuCode=&local_token=${geipToken}&viewMode=full`
      } else {
        window.location.href = `${window.location.protocol}//${window.location.host}/login`
      }
    },
    // 点击首页
    clickHome () {
      scrollTopFun()
      this.sentLog(100102001)
    },
    clickSolution (name) {
      scrollTopFun()
      if (name === '建设方') {
        this.sentLog(100102002)
      } else if (name === '施工方') {
        this.sentLog(100102003)
      } else if (name === '咨询方') {
        this.sentLog(100102004)
      }
    },
    // 回到顶部
    toTop () {
      scrollTopFun()
    },
    // 滚轮横向移动
    headerScroll () {
      this.headerOffset = -document.body.scrollLeft
    },
    // 点击应用案例
    clickCase () {
      this.sentLog(100102006)
    },
    // 点击平台动态
    clickNews () {
      this.sentLog(100102008)
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.headerScroll)
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.link-text {
  text-decoration: none;
  color: #1f1f1f;
}
::v-deep .el-backtop {
  background: rgba(31, 31, 31, 0.3);
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);
  user-select: none;
}
::v-deep .el-backtop:hover {
  background: rgba(31, 31, 31, 0.55);
}
.link-text:hover {
  color: #49f;
}
.land-container {
  min-width: 1200px;
  height: 100%;
  ::v-deep .router-link-active {
    text-decoration: none !important;
    float: left;
  }
  .submenu-title {
    display: contents;
    position: absolute;
  }

  .defaultColor {
    // background-color: rgba(255, 255, 255, 0.06) !important;
    background-color: #01044899 !important;
    transition-property: background-color;
    transition-duration: 1s;
  }
  .headerColor {
    background-color: #fff;
    box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.05);
    transition-property: background-color;
    transition-duration: 1s;
    border-bottom: 0 !important;
    ::v-deep .el-menu-item {
      color: #1f1f1f !important;
    }
    ::v-deep .el-submenu__title {
      color: #1f1f1f !important;
    }
    .el-menu-item:hover {
      color: #49f !important;
    }
    .el-menu-item.is-active {
      color: #49f !important;
    }
    ::v-deep .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
      color: #49f !important;
    }
    ::v-deep .el-menu--horizontal > .el-submenu:hover .el-submenu__title {
      color: #49f !important;
    }
  }

  .land-header {
    margin: 0 auto 0 auto;
    position: fixed;
    z-index: 1000;
    right: 0;
    bottom: 0;
    left: 0;
    top: 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
    padding: 0;
    min-width: 1280px;
    .land-header-div {
      width: 1200px;
      padding: 0px !important;
      margin: auto;
      ::v-deep .el-rol {
        width: auto;
      }
      ::v-deep .el-col-24 {
        width: auto;
      }
    }

    .land-header-logo {
      width: 242px;
      height: 64px;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .land-header-navs {
      display: flex;
    }
    .land-header-menu {
      flex: 1;
      padding: 0 220px 0 92px;
      font-size: 16px !important;
      font-weight: 500;
      color: #fff !important;
      line-height: 22px !important;
      user-select: none;
      box-sizing: border-box;
      ::v-deep .el-menu {
        border-bottom: 0;
        background-color: transparent !important;

        .ui {
          border-bottom: solid 1px #e6e6e6;
        }
        .el-menu-item {
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          line-height: 64px;
          height: 66px;
          background-color: transparent;
        }
        .el-submenu__title {
          font-size: 16px;
          font-weight: 500;
          color: #fff;
          line-height: 64px;
          height: 65px;
          background-color: transparent;
        }

        .el-menu-item:hover,
        .el-submenu__title:hover,
        .el-submenu__title:focus {
          background-color: transparent;
        }
        .el-menu-item.is-active {
          border-bottom: 3px solid #49f;
        }
        .el-submenu.is-active {
          border-bottom: 1px solid #49f;
        }
      }
    }

    .land-header-btn {
      width: 96px;
      height: 36px;
      ::v-deep .el-button {
        width: 96px;
        height: 36px;
        background: #49f;
        border-radius: 4px;
        font-size: 16px !important;
        font-weight: 400;
        color: #fff !important;
        margin: 14px 0;
        line-height: 0;
        border: 0;
      }
      ::v-deep .el-button:hover {
        background-color: #28f;
      }
    }
  }

  .land-home-carousel {
    height: 614px;
    background-color: #49f;

    ::v-deep .el-carousel__container {
      height: 614px;
    }
  }
}
</style>
